import styled from 'styled-components'
import { COLOR, FONT_SIZE, SIDE_BAR, TOPBAR_SIZE } from '../../themes'

const Style = styled.div`
  color: ${COLOR.BLACK_1};
  height: 100vh;
  position: absolute;
  top: 0;
  left: ${SIDE_BAR.WIDTH_SIZE};
  right: 0;
  bottom: 0;

  .box-filters {
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-bottom: 24px;
    
    > div {
      flex: 1;
    }

    .div-select-list {
      width: 100% !important;
      box-sizing: border-box;
      margin-top: 4px;
    }
  }

  .box-search-building,
  .box-search-floor {
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    padding: 0 16px;
    height: 48px;
    opacity: 1;
    width: 100%;
    display: flex;
    align-items: center;
    background-color: ${COLOR.WHITE};
    box-sizing: border-box;

    > input,
    .input-search-dropdown {
      font-family: NunitoRegular !important;
      font-size: 18px !important;
      font-weight: 400 !important;
      color: ${COLOR.BLACK_6} !important;
      margin: 0 !important;
      flex: 1 !important;
      border: none !important;
      outline: none !important;
      background: transparent !important;
      padding: 0 0 3px 0 !important;
      line-height: 1.5 !important;
      width: auto !important;
      height: auto !important;
    }

    > input::placeholder,
    .input-search-dropdown::placeholder {
      font-size: 18px !important;
      color: ${COLOR.GRAY_27} !important;
      padding: 3px 0 !important;
    }

    .icon-search-dropdown,
    .icon-cancel-dropdown {
      width: 16px;
      height: 16px;
      margin-left: 8px;
      cursor: pointer;
    }
  }

  .box-filters > .box-select-time {
    flex: 0 0 160px;
    display: flex;
    align-items: center;
    gap: 8px;
    height: 48px;
    padding: 0 16px;
    border: 1.5px solid ${COLOR.GRAY_5};
    border-radius: 8px;
    background-color: ${COLOR.WHITE};
    box-sizing: border-box;
    cursor: pointer;

    .icon-time {
      width: 18px;
      height: 18px;
    }

    .text-time {
      flex: 1;
      text-align: left;
      font-family: NunitoRegular;
      font-size: 18px;
      color: ${COLOR.BLACK_6};
    }

    .icon-expand {
      width: 16px;
      height: 16px;
    }
  }

  .body {
    height: calc(100% - ${TOPBAR_SIZE.LV_2});
    /* (max-screen) - (margin-top) - (padding-top-bottom) */
    max-height: calc(1080px - 76px + (-31px - 31px));
    margin-top: ${TOPBAR_SIZE.LV_2};
    overflow: scroll;
    padding: 16px 32px 31px 32px;
    box-sizing: border-box;
    > .box-bullet {
      display: flex;
      font-family: LibreBaskervilleRegular;
      font-size: ${FONT_SIZE.XXS};
      margin: 0px 10px;
    }
    > .box-content {
      margin: 0;
      position: relative;
    }
  }

  .box-legend {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    align-items: center;
    margin-bottom: 24px;
  }

  .legend-status {
    display: flex;
    flex-direction: row;
    gap: 16px;
    justify-self: start;
  }

  .legend-types {
    display: flex;
    flex-direction: row;
    gap: 24px;
    justify-self: center;
  }

  .legend-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .legend-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .legend-text {
    font-family: NunitoSansRegular, sans-serif;
    font-weight: 500;
    font-size: 16px;
    color: ${COLOR.BLACK_6};
  }

  .status-dot {
    box-sizing: border-box;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    border: 1px solid ${COLOR.BLACK_1};
  }

  .status-dot--available {
    background-color: ${COLOR.WHITE};
  }

  .legend-owner-icon {
    width: 16px;
    height: 16px;
    color: ${COLOR.BLACK_6};
    background-color: currentColor;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
    -webkit-mask-size: contain;
    mask-size: contain;
  }


  .content {
    margin: 0;
    position: relative;
  }

`

export default Style




